import styled from 'styled-components';
import {media, tokens} from "../../../theme";
import {Button} from "@mui/material";


export const DocumentAttachmentWrapper = styled.div<{ $show?: boolean }>`
    opacity: ${({ $show }) => ($show ? 1 : 0)};
    transition: opacity 0.5s ease-in-out;
    width: fit-content;
    max-width: 100%;
    
    ${media.sm} {
        max-width: 90%;
    }

    ${media.md} {
        max-width: 80%;
    }
`;

export const DocumentInfo = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

export const DocumentName = styled.div`
    font-size: ${tokens.fontSize.xs};
    font-weight: ${tokens.fontWeight.semibold};
    color: ${({ theme }) => theme.palette.text.primary};
    word-break: break-word;

    ${media.sm} {
        font-size: ${tokens.fontSize.sm};
    }
`;


export const StyledDownloadButton = styled(Button)`
    min-width: 30px !important;
    margin-left: 8px !important;

    .MuiButton-icon {
        margin: 0;
    }
`;

export const AttachmentFooter = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background: ${({ theme }) => theme.palette.message.userTextBg};
    border-radius: 0 ${tokens.radius.lg} ${tokens.radius.lg} 0;
    padding: 5px 12px;
    margin-bottom: 0;

    ${media.sm} {
        padding: 5px 16px;
    }
`;